import {ref, reactive, computed, watch, watchEffect} from 'vue';
import {usePaging} from "@/modules/reader/book/paging";
import config from "@/config/config.json";
import {saveAnswers as saveAnswersHistory, updateAnswersFromRemote as updateAnswersHistoryFromRemote}  from "@/modules/localDB/inlineExeriseHistory"

const inlineExerciseState = reactive({
    restoredEntireBookAnswers:null
})

export function useInlineExercise() {

    const {pageState, setCurrentPage} = usePaging();

    const reset = ()=> {
        inlineExerciseState.restoredEntireBookAnswers = null;
    }

    const updateEntireBookAnswers = (answers)=> {
        inlineExerciseState.restoredEntireBookAnswers = answers;
    }

    const saveAnswers = async (answers, pagenum)=>{
        await saveAnswersHistory(answers, pagenum)
    }

    const updateAnswersFromRemote = async(answers)=>{
        await updateAnswersHistoryFromRemote(answers);
    }


    return {
        inlineExerciseState,
        reset,
        updateEntireBookAnswers,
        updateAnswersFromRemote,
        saveAnswers
    }
}
